module.exports = __webpack_public_path__ + "img/reason_2.021f4445.png";